<script setup>
import TestimonialsBlock from "@/components/TestimonialsBlock.vue";

const testimonials = [
  {
    name: "Mike Traina",
    company: "Character Reference",
    excerpt:
      "Ashley is a person of high moral and ethical standards. She consistently demonstrates honesty, trustworthiness, and reliability in her endeavors...",
    route: "/testimonials/1",
  },
  {
    name: "Dale Schrobback",
    company: "Georgian Shores Construction Ltd.",
    excerpt:
      "As a construction labourer, Ashley was involved in a variety of projects that required a broad skill set and a strong work ethic...",
    route: "/testimonials/2",
  },
];
</script>

<template>
  <section id="about-me-section">
    <h2 class="section-title">About Me</h2>
    <p class="section-text mt-4">
      Hi I'm <em class="fw-bold text-primary">Ashley Friel</em>, a passionate business professional driven by community
      engagement, leadership, and collaboration. My journey has been shaped by a blend of education, hands-on
      experience, and a genuine desire to make a positive impact—both in the workplace and beyond.
    </p>
    <p class="section-text">
      With a Construction Project Management Certificate from George Brown College and currently obtaining a Business
      Diploma from Georgian College, I've developed a strong foundation in leadership, project coordination, and
      strategic problem-solving. I'm especially drawn to roles where I can build meaningful relationships, drive
      positive change, and foster inclusive team environments.
    </p>
    <p class="section-text">
      From coaching youth sports and volunteering at bottle drives for leukemia research, to creating engaging
      environmental science lessons for elementary students, my early experiences taught me the value of hard work,
      teamwork, and service. These moments helped define my approach to leadership—focused, supportive, and
      people-first.
    </p>
    <div class="row align-items-start gap-3">
      <div class="col-lg">
        <p class="section-text my-0">
          I've also had the opportunity to explore personal branding, human motivation, and professional development
          through projects like my Personal Marketing Package, where I honed in on my strengths: adaptability,
          people-orientation, and a collaborative mindset. Whether on a sports team, in the classroom, or leading a
          project, I believe success stems from honest communication, shared goals, and a willingness to grow. I'm
          committed to continuous learning, and I'm excited for what's ahead, bringing my knowledge, energy, and
          enthusiasm into every opportunity I pursue.
        </p>
      </div>
      <div class="col-lg-5">
        <img
          src="/images/ashley-friel-team-image.jpg"
          alt="Ashley Friel Team Image"
          class="rounded-4"
          style="width: 100%; height: auto"
        />
      </div>
    </div>
    <p class="section-text mb-0">Thanks for stopping by—I'd love to connect and collaborate!</p>
  </section>
  <section id="testimonials-section" class="mt-5">
    <h2 class="section-title">Testimonials</h2>
    <div class="testimonials-grid mt-4">
      <TestimonialsBlock v-for="testimonial in testimonials" :testimonial="testimonial" />
    </div>
  </section>
</template>

<style scoped lang="scss">
.testimonials-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 30px;

  @media (max-width: 992px) {
    grid-template-columns: 1fr;
  }
}
</style>
